import * as ApiManager from '../_manager'

export const adminSubscription = {

    list: (payload = null) => {
        return ApiManager.callApi (`/admin/subscription`, payload);
    },
    get: (payload = null) => {
        return ApiManager.callApi (`/admin/subscription/${payload.subscription_id}`, payload);
    },
    cancel: (payload = null) => {
        return ApiManager.callApi (`/admin/subscription/${payload.subscription_id}/cancel`, payload);
    },
    resume: (payload = null) => {
        return ApiManager.callApi (`/admin/subscription/${payload.subscription_id}/resume`, payload);
    },
}
